import request from '@/utils/request';

export function ToutiaoAPI () {
  return {
    // 获取广告回传列表
    getTTList: params => {
      return request ({
        url: '/admin/ad/index',
        method: 'get',
        params,
      });
    },
    //获取回传类型列表
    getType: params => {
      return request ({
        url: '/admin/ad/geteventtype',
        method: 'get',
        params,
      });
    },
    //添加回传 /admin/ad/add
    getAdd: params => {
      return request ({
        url: '/admin/ad/store',
        method: 'post',
        params,
      });
    },
    //编辑广告
    getEdit: params => {
      return request ({
        url: '/admin/ad/update',
        method: 'post',
        params,
      });
    },
    //广告详情
    getDetail: params => {
      return request ({
        url: '/admin/ad/show',
        method: 'get',
        params,
      });
    },
    //补传列表
    getcallbacklist: params => {
      return request ({
        url: '/admin/ad/getcallbacklist',
        method: 'get',
        params,
      });
    },
    //发送补传
    getcallbacksend: data => {
        return request ({
          url: '/admin/ad/callbacksend',
          method: 'post',
          data,
        });
      },
      //模拟联调
      gettestcallbacksend: data => {
        return request ({
          url: '/admin/ad/testcallbacksend',
          method: 'post',
          data,
        });
      },
  };
}
